import { apiClient } from './client'

// API response types
export interface FileMetadata {
  path: string
  name: string
  type: string
  size: number
  lastModified: string
  wordCount?: number
  tags?: string[]
  title?: string
  preview?: string
}

export interface FileContent {
  metadata: FileMetadata
  content: string
}

export interface FileChangeMessage {
  changeType: 'CREATED' | 'MODIFIED' | 'DELETED'
  path: string
  timestamp: string
  metadata?: FileMetadata
}

/**
 * Get all daily documentation files
 */
export const getDailyDocs = async (): Promise<FileMetadata[]> => {
  const response = await apiClient.get<FileMetadata[]>('/api/content/daily')
  return response.data
}

/**
 * Get a specific daily doc by date (YYYY-MM-DD)
 */
export const getDailyDoc = async (date: string): Promise<FileContent> => {
  const response = await apiClient.get<FileContent>(`/api/content/daily/${date}`)
  return response.data
}

/**
 * Get all reference documentation files
 */
export const getReferenceDocs = async (): Promise<FileMetadata[]> => {
  const response = await apiClient.get<FileMetadata[]>('/api/content/reference')
  return response.data
}

/**
 * Get all SQL files
 */
export const getSqlFiles = async (): Promise<FileMetadata[]> => {
  const response = await apiClient.get<FileMetadata[]>('/api/content/sql')
  return response.data
}

/**
 * Get file content by relative path
 */
export const getFileContent = async (relativePath: string): Promise<FileContent> => {
  const response = await apiClient.get<FileContent>('/api/content/file', {
    params: { path: relativePath }
  })
  return response.data
}

/**
 * Health check endpoint
 */
export const checkHealth = async (): Promise<{ status: string }> => {
  const response = await apiClient.get('/actuator/health')
  return response.data
}
